/**
 * *************************************************************************************************************
 * Responsibility - Conditionally renders its children based on a boolean condition. the component expects exactly
 * two children. The first child is rendered when the 'condition' prop is true, and the second child is
 * rendered when the 'condition' is false. 🐺
 * *******************************************
 *
 * @format
 */

import React from 'react';

export const IfElse = ({children, condition}) => {
    if (condition === true) {
        return children[0];
    }

    return children[1];
};
